// directives/v-fly-right.ts

interface FlyItem {
  el: HTMLElement;
  triggered: boolean;
}

const flyElements: FlyItem[] = [];

function applyFlyAnimation(el: HTMLElement, delay = 0) {
  el.style.transitionDelay = `${delay}ms`;
  el.style.transform = "translateX(0)";
}

function resetFlyStyle(el: HTMLElement) {
  // 获取视口宽度
  const translateX = document.documentElement.clientWidth / 2;

  el.style.transform = `translateX(${translateX}px)`;
  el.style.transitionProperty = "transform";
  el.style.transitionDuration = "2000ms";
  el.style.transitionTimingFunction = "cubic-bezier(0.25, 1, 0.5, 1)";
  el.style.transitionDelay = "1000ms";
}

export default {
  mounted(el: HTMLElement) {
    resetFlyStyle(el);

    const item: FlyItem = { el, triggered: false };
    flyElements.push(item);

    const observer = new IntersectionObserver(
      ([entry], obs) => {
        if (entry.isIntersecting) {
          if (!item.triggered) {
            applyFlyAnimation(el);
            item.triggered = true;
            obs.unobserve(el);
          }
        }
      },
      {
        root: null,
        threshold: 0,
        rootMargin: "0px 0px 0px 0px",
      }
    );

    observer.observe(el);
  },

  unmounted(el: HTMLElement) {
    const index = flyElements.findIndex((i) => i.el === el);
    if (index !== -1) flyElements.splice(index, 1);
  },
};
